import Html from 'react-pdf-html'

const HtmlContent = ({ styles, children }) => {
  return <Html style={styles}>{children}</Html>
}

export default HtmlContent
